/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Speed_DescriptionInputs */

const en_homepage_features_speed_description = /** @type {(inputs: Homepage_Features_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blaze through academic reading at the speed of light. Easily control the speed, at 10% increments.`)
};

const es_homepage_features_speed_description = /** @type {(inputs: Homepage_Features_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanza rápidamente por la lectura académica a la velocidad de la luz. Controla la velocidad fácilmente, en incrementos del 10%.`)
};

/**
* | output |
* | --- |
* | "Blaze through academic reading at the speed of light. Easily control the speed, at 10% increments." |
*
* @param {Homepage_Features_Speed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_speed_description = /** @type {((inputs?: Homepage_Features_Speed_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Speed_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_speed_description(inputs)
	return en_homepage_features_speed_description(inputs)
});